import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {Col, Glyphicon, Row} from "react-bootstrap";
import {Link} from 'react-router-dom';
import {loadGeneralEnum} from '../actions/enums';
import {countDogs, loadDogs} from '../actions/dogs';
import {showModal} from "../actions/modal";
import {resetPage, showMessage} from '../actions';
import {defaultState} from '../reducers/paginate';
import Dogs from '../components/dog/Dogs';
import {breadcrumbs} from "../utils";

class DogsPage extends Component {

	constructor(props) {
		super(props);

		this.handleFetchData = this.handleFetchData.bind(this);
		this.handleFetchEnums = this.handleFetchEnums.bind(this);
	}

	componentWillMount() {
		this.props.loadGeneralEnum('breed', {});
	}

	componentWillReceiveProps(nextProps) {
	}

	componentWillUnmount() {
		this.props.resetPage();
	}

	handleFetchEnums(enums, filter = {}) {
		for (const i in enums) {
			if (enums.hasOwnProperty(i)) {
				this.props.loadGeneralEnum(enums[i], filter)
			}
		}
	}

	handleFetchData(filter) {
		this.props.loadDogs(filter);
		this.props.countDogs(filter);
	}

	render() {
		const {page, enums, session} = this.props;

		return (
			<div>
				<Row>
					<Col xs={8}>
						{breadcrumbs([{title: 'Psi'}])}
					</Col>
					<Col xs={4}>
						<Link to={{pathname: "/psi/novy"}} className="btn btn-success pull-right"><Glyphicon glyph="plus"/> Nový pes</Link>
					</Col>
				</Row>
				<Dogs {...page} enums={enums} session={session}
					onFetchEnums={this.handleFetchEnums}
					onFetchData={this.handleFetchData}
					onShowModal={this.props.showModal}
					onShowMessage={this.props.showMessage}
				/>
			</div>
		)
	}
}

DogsPage.propTypes = {
	page: PropTypes.object,
	enums: PropTypes.object,
	loadGeneralEnum: PropTypes.func.isRequired,
	loadDogs: PropTypes.func.isRequired,
	countDogs: PropTypes.func.isRequired,
	showMessage: PropTypes.func.isRequired,
	resetPage: PropTypes.func.isRequired,
	session: PropTypes.object.isRequired,
	showModal: PropTypes.func.isRequired
};


const mapStateToProps = (state, ownProps) => {
	const {
		pagination: {dogs},
		enums,
		session
	} = state;

	const page = dogs[0] || defaultState;

	return {
		page,
		enums,
		session
	}
};

export default connect(mapStateToProps, {
	loadGeneralEnum,
	loadDogs,
	countDogs,
	showMessage,
	resetPage,
	showModal
})(DogsPage)



// WEBPACK FOOTER //
// ./src/containers/DogsPage.js